import { render, staticRenderFns } from "./CompanyActivateModal.vue?vue&type=template&id=65f124f4&"
import script from "./CompanyActivateModal.vue?vue&type=script&lang=js&"
export * from "./CompanyActivateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports